import type { ResponseCluster, ResponseText } from '@mentimeter/http-clients';
import { UNGROUPED_CLUSTER_ID } from '../../groups';

export function createUngroupedGroup({
  ungroupedResponses = [],
  label,
  clusteringId,
}: {
  ungroupedResponses: ResponseText[];
  label: string;
  clusteringId: string | undefined;
}): ResponseCluster | undefined {
  if (!ungroupedResponses.length) {
    return undefined;
  }
  return {
    id: UNGROUPED_CLUSTER_ID,
    responses: ungroupedResponses.map((response) => ({
      ...response,
      cluster_id: 'ungrouped_id',
    })),
    label,
    clustering_id: clusteringId ?? '',
    total_upvotes: ungroupedResponses.reduce<number>((acc, response) => {
      return acc + (response.upvotes ?? 0);
    }, 0),
  };
}
